import React from 'react';
import { AiOutlineClose } from 'react-icons/ai';
import './ModalDetalle.css';

const Modal = ({ isOpen, onClose, titulo, resumen, tacs, cuerpo }) => {
  const handleClose = () => {
    onClose();
  };

  if (!isOpen) {
    return null;
  }

  return (
    <>
      <div className="modal-overlay-detalles" onClick={handleClose}></div>
      <div className="modal-wrapper-detalles">
        <div className="modal-content-detalles">
          
          <div className="modal-header-detalles">
            Detalle del contexto 
            <button className="modal-header-detalles-close">
                <AiOutlineClose onClick={handleClose} />
            </button>
          </div>
          <div className="modal-body-detalles">
            <h3>{titulo}</h3>
            {resumen !==' Aca va el resumen'&&( 
               <>
               <h4>Resumen</h4>
               <p>{resumen}</p>
               <h4>Tacs</h4>
               <p>{tacs}</p>
               <h4>Cuerpo</h4>
               <p>{cuerpo}</p>
             </> 
            )}
              {resumen ===' Aca va el resumen'&&( 
               <>
               <h4>Cuerpo</h4>
               <p>{cuerpo}</p>
             </> 
            )} 
          </div>
        </div>
      </div>
    </>
  );
};

export default Modal;
